import useCart from 'modules/cart/util/use-cart';
import {SizeProps} from 'modules/products/types';
import getSizeSale from 'modules/products/util/get-size-sale';
import React, {useMemo} from 'react';
import Row from 'shared/components/row';
import {MediumText} from 'shared/components/text';
import isNumber from 'shared/util/is-number';
import toBrl from 'shared/util/to-brl';

const SizePrice: React.FC<SizeProps & {productIndex?: number}> = (props) => {
  const {price, productIndex, remainingProducts, saleId, onePerOrder} = props;
  const {cart} = useCart();

  const sizeSale = getSizeSale(props);

  const soldOutSale = useMemo(() => {
    if (!isNumber(remainingProducts)) return false;

    const cartSaleQuantity = (cart?.products ?? []).reduce(
      (sum, someProduct) =>
        someProduct.saleId && someProduct.saleId === saleId
          ? sum + someProduct.quantity
          : sum,
      0,
    );

    return cartSaleQuantity >= (remainingProducts ?? 0);
  }, [cart, remainingProducts, saleId]);

  const hideSale = useMemo(() => {
    if (onePerOrder)
      return cart?.products.find(
        (someProduct, index) =>
          index !== productIndex &&
          !!someProduct.saleId &&
          someProduct.onePerOrder &&
          saleId === someProduct.saleId,
      );

    return soldOutSale;
  }, [cart, saleId, productIndex, onePerOrder, soldOutSale]);

  return (
    <>
      {sizeSale && !hideSale && (
        <Row gap={5}>
          <MediumText>+</MediumText>
          <MediumText color="green">{toBrl(sizeSale.salePrice)}</MediumText>
          <MediumText
            color="opaqueText"
            size="small"
            style={{textDecorationLine: 'line-through'}}>
            {toBrl(sizeSale.price)}
          </MediumText>
        </Row>
      )}
      {(!sizeSale || hideSale) && (
        <MediumText size="small">+ {toBrl(price)}</MediumText>
      )}
    </>
  );
};

export default SizePrice;
